import { Navigate, useRoutes, Outlet } from 'react-router-dom';
// layouts
import { GuestGuard } from 'src/auth/guard';
import Layout from 'src/layouts/layout';
import { LoginPage, ForgotPasswordPage, VerifyEmailPage, ResetPasswordPage } from './main';
import { dashboardRoutes } from './dashboard';
// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    // ----------------------------------------------------------------------

    // SET INDEX PAGE WITH HOME PAGE
    {
      path: '/',
      element: (
        <GuestGuard>
          <Outlet />
        </GuestGuard>
      ),
      children: [
        { element: (
          <Layout>
            <LoginPage />
          </Layout>
        ), index: true },
        {
          path: 'auth/login',
          element: (
            <Layout>
              <LoginPage />
            </Layout>
          ),
        },
        {
          path: 'auth/forgot-password',
          element: (
            <Layout>
              <ForgotPasswordPage />
            </Layout>
          ),
        },
      ],
    },
    // Verify email (public route)
    {
      path: 'verify-email',
      element: (
        <Layout>
          <VerifyEmailPage />
        </Layout>
      ),
    },
    // Reset password (public route)
    {
      path: 'reset-password/:token',
      element: (
        <Layout>
          <ResetPasswordPage />
        </Layout>
      ),
    },
    // Reset password with auth prefix (for set password emails)
    {
      path: 'auth/reset-password/:token',
      element: (
        <Layout>
          <ResetPasswordPage />
        </Layout>
      ),
    },

    // Dashboard routes
    ...dashboardRoutes,

    // No match 404
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
